import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({ selector: '[appEnterAsTab]' })
export class EnterAsTabDirective {
    constructor(private el: ElementRef<HTMLInputElement>) { }

    @HostListener('keydown.enter', ['$event'])
    onEnter(event: KeyboardEvent) {
        event.preventDefault();
        const form = this.el.nativeElement.form;
        if (!form) { return; }

        const elements = Array.from(form.elements) as HTMLElement[];
        const index = elements.indexOf(this.el.nativeElement);
        const next = elements[index + 1];
        if (next) {
            next.focus();
        }
    }
}
